import { gql, useApolloClient } from '@apollo/client'
import { Box, Grid } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { useToasts } from 'react-toast-notifications'
import { Alert, AlertTitle } from '@material-ui/lab'
import { useLocation } from '@reach/router'
import queryString from 'query-string'
import { VisibilityState } from './types'

declare let AppStream: any

const FETCH_INVITE_STREAMING_INFO = gql`
  query joinCssStreamingSession($sessionID: String!) {
    joinCssStreamingSession(sessionID: $sessionID) {
      url
    }
  }
`
const SharedStreamingClientComponent = observer(() => {
  let appstreamEmbed: any
  const { addToast } = useToasts()
  const client = useApolloClient()
  const location = useLocation()
  const [streamingEmbedVisibility, setStreamingEmbedVisibility] = React.useState<VisibilityState>('visible')
  const [sharedSessionStarted, setSharedSessionStarted] = React.useState(false)
  const [alertMessage, setAlertMessage] = React.useState('')
  const [alertTitle, setAlertTitle] = React.useState('')

  React.useEffect(() => {
    if (location.search && !sharedSessionStarted) {
      console.log('SEARCH', location.search)
      const queryObj = queryString.parse(location.search)

      //sharedSessionID
      if (queryObj.sharedSessionID) {
        console.log('found session..')
        console.log(queryObj.sharedSessionID)
        setSharedSessionStarted(true)
        launchAppStreamSession(queryObj.sharedSessionID as string)
      } else {
        console.log('no valid session.')
        setAlertMessage('Invalid, or expired streaming session link.')
        setAlertTitle('Streaming Session Not Found')
        setStreamingEmbedVisibility('hidden')
      }
    }
  })
  const launchAppStreamSession = (sessionID: string) => {
    client
      .query({
        query: FETCH_INVITE_STREAMING_INFO,
        variables: {
          sessionID: sessionID
        },
        fetchPolicy: 'no-cache'
      })
      .then((response) => {
        console.log(response)
        const { joinCssStreamingSession } = response.data
        if (joinCssStreamingSession.url && joinCssStreamingSession.url.length > 0) {
          const userInterfaceConfig = {}
          userInterfaceConfig[AppStream.Embed.Options.HIDDEN_ELEMENTS] = [AppStream.Embed.Elements.TOOLBAR]
          const appstreamOptions = {
            sessionURL: joinCssStreamingSession.url,
            userInterfaceConfig: userInterfaceConfig
          }
          addToast('Starting your session, please wait.', {
            appearance: 'info'
          })

          appstreamEmbed = new AppStream.Embed('appstream-container', appstreamOptions)

          appstreamEmbed.addEventListener(AppStream.Embed.Events.SESSION_ERROR, errorCallback)
        }
      })
      .catch((error) => {
        console.error(error)
        setAlertMessage('Invalid, or expired streaming session link.')
        setAlertTitle('Streaming Session Not Found')
        setStreamingEmbedVisibility('hidden')
      })
  }
  function errorCallback(event) {
    console.log('APPSTREAMERROR', JSON.stringify(event))
    setStreamingEmbedVisibility('hidden')
  }

  return (
    <div id='root' style={{ overflow: 'hidden' }}>
      <div
        id='appstream-container'
        style={{
          visibility: streamingEmbedVisibility,
          width: '100vw',
          height: '100vh',
          margin: 'auto',
          minWidth: '640px',
          minHeight: '525px'
        }}
      >
        <Box hidden={streamingEmbedVisibility === 'hidden' ? false : true}>
          <Grid
            container
            direction='row'
            alignItems='center'
            alignContent='center'
            justifyContent='space-around'
            style={{
              visibility: streamingEmbedVisibility === 'visible' ? 'collapse' : 'visible'
            }}
          >
            <Grid item xs={12} style={{ marginBottom: '12px' }}>
              <Alert severity='error'>
                <AlertTitle>{alertTitle}</AlertTitle>
                {alertMessage}
              </Alert>
            </Grid>
          </Grid>
        </Box>
      </div>
    </div>
  )
})

export default SharedStreamingClientComponent
